import { c as _c } from "react/compiler-runtime";
import { Drawer } from '@systemeio/components';
import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
interface NavbarDrawerProps {
  children: ReactNode;
  className?: string;
}
export function NavbarDrawer(t0) {
  const $ = _c(7);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      className: "inset-x-0 top-12 bottom-0 z-40"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = twMerge("border-border-200 bg-bg-primary shadow-2 tablet:max-w-95 w-full border-t", className);
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      className: "inset-x-0 top-12 bottom-0 z-40"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children || $[5] !== t2) {
    t4 = <Drawer.Popup backdropProps={t1} className={t2} viewportProps={t3}>{children}</Drawer.Popup>;
    $[4] = children;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}